<template>
  <div class="mb-3">
    <div class="mb-3">
      <argon-input
        type="password"
        placeholder="Old Password"
        name="oldPassword"
        size="lg"
        class="w-35"
        v-model:value.sync="oldPassword"
      />
    </div>
    <div class="mb-3">
      <argon-input
        type="password"
        placeholder="Password"
        name="password"
        size="lg"
        class="w-35"
        v-model:value.sync="password"
      />
    </div>
    <div class="mb-3">
      <argon-input
        type="password"
        placeholder="Confirm Password"
        name="confirmPassword"
        size="lg"
        class="w-35"
        v-model:value.sync="confirmPassword"
      />
    </div>
    <div class="text-center" style="display: flex">
      <argon-button
        class="changePassword__button mt-4 2-15"
        variant="gradient"
        color="success"
        size="lg"
        @click="Save"
        :isLoading="saveButtonClicked"
        :isLoadingText="'Saving...'"
        >Save</argon-button
      >
      <argon-button
        class="changePassword__button mt-4 ms-6"
        variant="outline"
        color="success"
        size="lg"
        @click="
          () => {
            ResetData();
            close();
          }
        "
        :isLoadingText="'wait'"
        >Cancel</argon-button
      >
    </div>
  </div>
</template>

<style scoped>
.dataSubscriptionWripper {
  padding: 10px;
}

.changePassword__button {
  width: 15%;
}

@media only screen and (max-width: 1610px) {
  .changePassword__button {
    width: auto;
  }
}
</style>

<script>
import "mosha-vue-toastify/dist/style.css";
import { ArgonInput, ArgonButton } from "@/components/exporter.js";
import { Toaster } from "../../../../customFunctions/Utils.js";
import { Validator } from "../../../../customFunctions/Validator.js";
import { SendPOSTUserAPI } from "../../../../customFunctions/Api.js";
import { mapGetters } from "vuex";

export default {
  name: "change-password-container",
  components: { ArgonInput, ArgonButton },
  data() {
    return {
      oldPassword: "",
      password: "",
      confirmPassword: "",
      saveButtonClicked: false,
    };
  },
  methods: {
    async Save() {
      this.saveButtonClicked = true;
      if (!this.Validate()) {
        this.saveButtonClicked = false;
        return;
      }

      const body = {
        username: this.getUserData.email,
        currentPassword: this.oldPassword,
        newPassword: this.password,
      };
      const response = await SendPOSTUserAPI(
        "users/change-password",
        null,
        body
      );
      if (response.statusCode && response.statusCode !== 200) {
        Toaster(
          response.message ? response.message : "Some Error, Please Try Again",
          "",
          "danger"
        );
        this.saveButtonClicked = false;
        return;
      }
      this.saveButtonClicked = false;
      Toaster("Successfully Changed!", "", "success");
    },
    Validate() {
      Validator.validatePassword(this.oldPassword, 'Old Password');
      Validator.validatePassword(this.password);
      if (this.getAuth0PasswordPolicyEnabled) {
        Validator.validateStrongPassword(this.password);
      }
      Validator.validatePassword(this.confirmPassword, 'Confirm Password');
      Validator.validateConfirmPassword(this.password, this.confirmPassword);
      return !Validator.validateIfHasError(Toaster);
    },
    ResetData() {
      this.oldPassword = "";
      this.password = "";
      this.confirmPassword = "";
    },
  },
  computed: {
    ...mapGetters(["getUserData", "getAuth0PasswordPolicyEnabled"]),
  },
  setup() {
    return { Toaster };
  },
  props: ["close"],
};
</script>
